module.exports = __webpack_public_path__ + "static/media/bg.114e1143.jpg";